import React from "react";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const ContactOption = ({ item }) => {
  const matchesSm = useMediaQuery("(max-width:1280px)");

  return (
    <Grid
      container
      alignItems="center"
      style={{ marginBottom: "5rem" }}
      className="contact-option"
    >
      <Grid
        item
        style={
          matchesSm ? { margin: "0 5rem 2rem 0" } : { marginRight: "5rem" }
        }
      >
        <h2
          style={{
            padding: "0.2rem 0.5rem 0.3rem",
            color: "#222831",
            backgroundColor: "#EEEEEE",
          }}
          className="contact-option-title"
        >
          {item.title}
        </h2>
      </Grid>
      <Grid item>
        <Grid container alignItems="center" style={{ marginBottom: "1.5rem" }}>
          <Grid item style={{ marginRight: "2rem" }}>
            {item.icon1}
          </Grid>
          <Grid item>
            <h2>{item.content1}</h2>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid item style={{ marginRight: "2rem" }}>
            {item.icon2}
          </Grid>
          <Grid item>
            <h2>{item.content2}</h2>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContactOption;
